import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_INPUT_STOCK_REPORT_API} from '@app/reactQuery/apis/constants/rqInputStockReportAPIConstants';

export const RQUseGetInputStockReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_input_stock_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_INPUT_STOCK_REPORT_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};
